import {
  ORDER_STATUS_COLORS,
  ORDER_STATUS_DISPLAY,
} from "@miplatform/constants";
import { OrderStatus } from "@miplatform/types";
import { StatusDisplayChip } from "../StatusDisplayChip/StatusDisplayChip";

export const OrderStatusDisplayChip = ({
  status,
}: OrderStatusDisplayChipProps) => {
  const statusName = ORDER_STATUS_DISPLAY[status] || "Unknown";
  const statusColor = ORDER_STATUS_COLORS[status] || "grey";

  return (
    <StatusDisplayChip statusName={statusName} statusColor={statusColor} />
  );
};

interface OrderStatusDisplayChipProps {
  status: OrderStatus;
}
